/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class UserFixedAlertEntity extends Entity {
  beachWithExperienceAlertActive: boolean = false;
  clientCreatedAccountAlertActive: boolean = false;
  clientCreatedOppAlertActive: boolean = false;
  clientReqInterviewAlertActive: boolean = false;
  clientSearchedInAfcAlertActive: boolean = false;
  clientSignedInAlertActive: boolean = false;
  createdAt: string | null = null;
  id: string = '';
  talentSelectedOnOppAlertActive: boolean = false;
  updatedAt: string | null = null;
  userId: string | null = null;
  waitlistWithExperienceAlertActive: boolean = false;
  static override key = 'UserFixedAlert';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'UserFixedAlert' in input
    ) {
      const { UserFixedAlert: wrapped, ...rest } = input as {
        UserFixedAlert: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}